<template>
    <div class="screen white--text" style="background: none transparent;">
        <table>
            <tr>
                <td width="50%">
                    <stream-total-team :spiel="spiel" team="heim"></stream-total-team>
                </td>
                <td width="50%">
                    <stream-total-team :spiel="spiel" team="gast"></stream-total-team>
                </td>
            </tr>
        </table>
        <table class="result text-center">
            <tr v-if="spiel" style="height: 80px">
                <td v-if="!isCup" class="single">&#8709; {{spiel.heim.result.schnitt}}</td>
                <td v-else class="single">{{spiel.heim.result.fw}} <span style="font-size: 24px">FW</span></td>
                <td class="double">
                    <span v-if="!isCup">{{spiel.heim.result.kegel}} <span style="font-size: 24px">Kegel</span></span>
                    <span v-else>{{spiel.heim.result.ar}} <span style="font-size: 24px">Abräumen</span></span>
                </td>
                <td v-if="!isCup" :class="[{'green--text': heimResult >= 0},
                             {'red--text': heimResult < 0}, 'single font-weight-medium']">
                    {{heimResult}}
                </td>
                <td v-else :class="spiel.getCSSColorCup('heim', ['single font-weight-medium'])">
                    {{spiel.heim.result.kegel}}</td>
                <td v-if="!isCup" class="single singleResult font-weight-medium">
                    {{spiel.heim.result.mp}} : {{spiel.gast.result.mp}}</td>
                <td v-else class="single singleResult font-weight-medium">
                    {{spiel.getKegelDeltaSign('heim')}}
                    {{Math.abs(spiel.heim.result.kegel-spiel.gast.result.kegel)}}
                    {{spiel.getKegelDeltaSign('gast')}}
                </td>
                <td v-if="!isCup" :class="[{'green--text': gastResult >= 0},
                             {'red--text': gastResult < 0}, 'single font-weight-medium']">
                    {{gastResult}}
                </td>
                <td v-else :class="spiel.getCSSColorCup('gast', ['single font-weight-medium'])">
                    {{spiel.gast.result.kegel}}</td>
                <td class="double">
                    <span v-if="!isCup">{{spiel.gast.result.kegel}} <span style="font-size: 24px">Kegel</span></span>
                    <span v-else>{{spiel.gast.result.ar}} <span style="font-size: 24px">Abräumen</span></span>
                </td>
                <td v-if="!isCup" class="single">&#8709; {{spiel.gast.result.schnitt}}</td>
                <td v-else class="single">{{spiel.gast.result.fw}} <span style="font-size: 24px">FW</span></td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import StreamTotalTeam from "./streamTotalTeam";

    export default {
        components: {StreamTotalTeam},
        name: "stream-total",
        props: ['partie'],
        computed: {
            isCup(){ return this.spiel.saison.isCup},
            heimResult(){return this.spiel ? this.spiel.heim.result.kegel-this.spiel.gast.result.kegel : 0},
            gastResult(){return this.spiel ? this.spiel.gast.result.kegel-this.spiel.heim.result.kegel : 0},
        },
        data: () => ({
            spiel: null,
            spielRaw: null,
        }),
        created(){
            this.setSpielRaw();
            //window.print();
        },
        mounted () {
            document.body.classList.add('hideScrollbar')
        },
        destroyed () {
            document.body.classList.remove('hideScrollbar')
        },
        methods: {
            setSpielRaw(){
                db.collection("spiele").doc(this.$route.query.id)
                    .onSnapshot((doc) => {
                        this.spielRaw = doc.data();
                        this.spielRaw.id = doc.id;
                    });
            },
            setSpiel(){
                this.spiel = new Spiel();
                this.spiel.setFromDataObject(this.spielRaw);
            },
        },
        watch: {
            spielRaw: {
                handler(){
                    this.setSpiel();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .screen { width: 1670px; position: absolute; top: 0; left: 0; }
    .result{width: 1670px; font-size: 36px}
    table { font-size: 24px; border-collapse: collapse; background-color: #333; }
    .single {width: 184px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;}
    .singleResult {font-size: 48px; background-color: #454545}
    .double {width: 366px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;}
</style>